import type { IAdminProcess } from '@frontend/components/interfaces/adminProcessesList';
import type { IProcess } from '../components/interfaces/process';
import { RequestStatus } from '../../common/enums/requestStatus';
import { ServiceType } from '../../common/enums/serviceType';

export function canChangeCareProvider(process: IProcess | IAdminProcess) {
    const serviceTypeEntry = Object.entries(process).filter(
        ([key, value]) => ['service', 'serviceType'].includes(key) && !!value
    )[0];
    const serviceTypeValue = serviceTypeEntry[0] === 'service' ? serviceTypeEntry[1].serviceType : serviceTypeEntry[1];

    if (serviceTypeValue === ServiceType.invitation) {
        return false;
    }

    if ([RequestStatus.aborted, RequestStatus.cancelled].includes(process.status)) {
        return false;
    }

    return true;
}
